var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"mb-5 pa-4 card-border",class:_vm.publication.pinned ? 'card-border-green' : 'card-border-blue'},[_c('v-card-text',{staticClass:"pa-0",domProps:{"innerHTML":_vm._s(_vm.publication.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }